import { useEntity, useRelatedEntities } from '@backstage/plugin-catalog-react';
import { RELATION_HAS_PART } from '@backstage/catalog-model';

import { slackLinks, uniqueSlackLinks } from './utils';
import { SlackCard } from './SlackCard';

export const SystemSlackCard = () => {
  const { entity } = useEntity();
  const { entities = [] } = useRelatedEntities(entity, {
    type: RELATION_HAS_PART,
    kind: 'Component',
  });

  const allChannels = entities.flatMap(component => slackLinks(component));

  return <SlackCard links={uniqueSlackLinks(allChannels)} />;
};
